import React, { useEffect, useState } from 'react';
import { ApolloError, useLazyQuery } from 'apollo-client-ppc';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import { fetchResourceIdsFromContact } from './queries/fetch-resource-ids-from-contact';
import { ContactType } from './constant';

export interface ResourceContact {
  resourceId: string;
  resourceType: string;
}

export const useFetchIdsFromContactEmail = ({ transactionAccountId }: { transactionAccountId: string }) => {
  const ansClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.ANS), []);

  const [fetchContactIds, { loading: isIdsLoading, error }] = useLazyQuery(fetchResourceIdsFromContact, {
    client: ansClient as any,
  });

  const [fetchIdsError, setFetchIdsError] = useState<ApolloError | undefined>(undefined);

  useEffect(() => {
    setFetchIdsError(error);
  }, [error]);

  const getResourceIdsFilterOptions = async (email: string) => {
    const { data } = await fetchContactIds({
      variables: {
        contactEmail: email,
        contactType: [ContactType.QUOTE_CONTACT, ContactType.CUSTOMER_CONTACT],
        transactionAccountId: transactionAccountId,
      },
    });

    const invoiceGroupIds = (data?.resourcesByContact ?? [])
      .filter((contact: ResourceContact) => contact.resourceType === 'invoice-group')
      .map((contact: ResourceContact) => contact.resourceId);

    const quoteIds = (data?.resourcesByContact ?? [])
      .filter((contact: ResourceContact) => contact.resourceType === 'quote')
      .map((contact: ResourceContact) => contact.resourceId);

    return isIdsLoading
      ? null
      : [
          { key: 'invoiceGroupIdIsIn', values: invoiceGroupIds.length > 0 ? invoiceGroupIds : [''] },
          { key: 'idIsIn', values: quoteIds.length > 0 ? quoteIds : [''] },
        ];
  };

  return {
    getResourceIdsFilterOptions,
    isIdsLoading,
    fetchIdsError,
    setFetchIdsError,
  };
};
